import React from 'react';
import {observer} from 'mobx-react';
import ModalSimple from '../../../global/modal-simple';

declare var __company_name: string;
declare var __domain_name: string;

type Props = {
    portalID?: number;
};

@observer
class ReturnPolicyModal extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <ModalSimple
                id="modal-return-policy"
                title={`${__company_name} Return Policy`}
            >
                <div>
                    <p>
                        {__company_name} offers a hassle-free return policy with no restocking fees to ensure customer satisfaction. Purchases made directly from their website are refundable within {this.props.portalID === 3 ? '30' : '120'} days, with options to replace the product or issue a
                        refund, excluding shipping and handling fees. Returns require a Return Merchandise Authorization (RMA) number, provided by their Customer Service team, and must be in original, undamaged packaging. For damaged frames, replacements are fast-tracked and shipped within five
                        business days, with all shipments fully insured. Personalized engraved plates and special-order items are typically non-returnable unless there’s an error or defect.
                    </p>
                    {this.props.portalID !== 3 && <p>For purchases made through bookstores or affiliates, customers must follow the store's specific return policies. eGift cards are non-refundable and any returns for items purchased with them will be credited back to the card.</p>}
                    <p>{__company_name} emphasizes customer support and encourages anyone with questions to contact their Customer Service team for assistance.</p>

                    <div>
                        <a
                            href={this.props.portalID !== 3 ? `/customer-service/return-policy` : `/return-policy`}
                            className="link underline"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Learn more about our ${this.props.portalID === 3 ? '30' : '120'} day return policy`}
                        >
                            Read full return policy
                        </a>
                    </div>
                </div>
            </ModalSimple>
        );
    }
}

export default ReturnPolicyModal;
